import React, { useState } from "react";
import { Button, Menu } from "@mui/material";
import PlaceholderPicker from "../../../components/management/PlaceholderPicker";

export function MenuButtonInsertPlaceholder({ editor, t }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleSelect = (p) => {
        setAnchorEl(null);
        if (!editor) return;
        editor.chain().focus().insertPlaceholder({ key: p.key, label: p.label }).run();
    };

    return (
        <>
            <Button
                size="small"
                variant="outlined"
                onMouseDown={(e) => e.preventDefault()}
                onClick={(e) => setAnchorEl(e.currentTarget)}
                disabled={!editor}
            >
                {t("insertPlaceholderAtCursor")}
            </Button>

            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
                PaperProps={{ sx: { maxHeight: 500 } }}
                autoFocus={false}
                disableAutoFocusItem
            >
                <PlaceholderPicker onSelect={handleSelect} />
            </Menu>
        </>
    );
}
